// export const BASE_URL = 'http://localhost:8080';
export const BASE_URL = 'https://portfolio-2cbv.onrender.com';

export const URLS = {
  createProject: '/projects',
  getProjects: '/projects',
  login: '/auth/login',
  deleteProject: (id) => `/projects/${id}`,
  updateProject: (id) => `/projects/${id}`,
  filterProject: '/projects/filter',
  sendEmail: '/send-email'
};
